module.exports = __webpack_public_path__ + "3f16e137/img/archive-icon.0a6a9de3.svg";